<header class="flex">
  <div class="flex w-full">
    @for (step of steps; track step; let i = $index) {
      <div (click)="selectStepByIndex(i)" class="flex">
        <a class="px-[20px] py-[12px] transparent cursor-pointer" [class.active]="selectedIndex === i">
          {{step.label}}
        </a>
      </div>
    }
  </div>
</header>

<ng-container [ngTemplateOutlet]="selected ? selected.content : null"></ng-container>
